module.exports = __webpack_public_path__ + "img/crowdfundinsider.c3e9773e.png";